import styles from './Form.module.css';
import {Bounce} from "react-awesome-reveal";
import peopleImg from "./peoples.png"
import React from "react";
function Form(props) {
  return (
      <div>
          <br/>
          <br/>
          <div style={{background: '#276A9F'}}>
              <center>
                  <div className={styles.header}>Schnell zu Ihrer perfekten Reinigung</div>
              </center>
          </div>
          <div className="wrapper">


              <div className="grid">
                  <div className="displayLarge lg:col-6 col-12">
                      <img className={styles.img} src={peopleImg}/>
                  </div>
                  <div className="lg:col-6 col-12">
                      <div className="displayLarge" style={{height: 10}}>
                      </div>
                      <Bounce triggerOnce>
                          <div className={styles.item}>
                              <table>
                                  <tbody>
                                  <tr>
                                      <td>
                                          <div className={styles.itemNumber}>1</div>
                                      </td>
                                      <td>
                                          <div className={styles.itemHeader}>Terminvereinbarung</div>
                                          <div className={styles.itemText}>Ein kurzer Moment genügt – und wir kümmern uns um den Rest. Teilen Sie uns Ihr Anliegen mit oder buchen Sie direkt einen Vor‑Ort‑Termin. Schnell, persönlich und so unkompliziert, wie Sie es sich wünschen.</div>
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                          </div>
                      </Bounce>

                      <Bounce triggerOnce delay={1000}>
                          <div className={styles.item}>
                              <table>
                                  <tbody>
                                  <tr>
                                      <td>
                                          <div className={styles.itemNumber}>2</div>
                                      </td>
                                      <td>
                                          <div className={styles.itemHeader}>Bearbeitung</div>
                                          <div className={styles.itemText}>Beim gemeinsamen Termin nehmen wir uns Zeit für das, was Ihnen wichtig ist. Wir hören zu, stellen die richtigen Fragen und entwickeln eine Lösung, die exakt zu Ihren Räumen, Abläufen und Erwartungen passt. Ihr Anspruch wird zu unserem Maßstab.</div>
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                          </div>
                      </Bounce>

                      <Bounce triggerOnce delay={2000}>
                          <div className={styles.item}>
                              <table>
                                  <tbody>
                                  <tr>
                                      <td>
                                          <div className={styles.itemNumber}>3</div>
                                      </td>
                                      <td>
                                          <div className={styles.itemHeader}>Angeboterstellung</div>
                                          <div className={styles.itemText}>Im Anschluss erhalten Sie ein transparentes, unverbindliches Angebot – klar strukturiert, fair kalkuliert und individuell auf Sie zugeschnitten. Ein Angebot, das zeigt: Wir haben verstanden, worauf es Ihnen ankommt.</div>
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                          </div>
                      </Bounce>
                  </div>
              </div>
          </div>
      </div>

  );
}

export default Form;
